import React, { useMemo, useState } from 'react';
import { observer } from 'mobx-react';
import {
    Block,
    FlexDiv,
    ProgressWithNumber,
    SearchInput,
} from '@awarego-ui/components';
import TableClient from '../../../../components/table/TableClient';

function ScormScenarios({ training }) {
    const [filter, setFilter] = useState('');

    const scenarios = useMemo(
        () =>
            (training?._rawData?.subjects || []).map((s) => ({
                ...s,
                score:
                    s.score ??
                    (s.answered || 0) * 0.5 + (s.viewed || 0) * 0.5,
            })),
        [training?._rawData?.subjects]
    );

    const filtered = useMemo(() => {
        if (!filter) return scenarios;
        const term = filter.toLowerCase();
        return scenarios.filter((s) =>
            Object.values(s).some((v) =>
                String(v || '').toLowerCase().includes(term)
            )
        );
    }, [scenarios, filter]);

    const columns = useMemo(
        () => [
            {
                Header: 'Scenario',
                accessor: 'name',
                Cell: (x) => <div className="row-title">{x.value}</div>,
            },
            {
                Header: 'Completion rate',
                accessor: 'score',
                Cell: (x) => (
                    <ProgressWithNumber
                        value={
                            x.row.original.total
                                ? Math.round(
                                      (100 * x.value) / x.row.original.total
                                  )
                                : 0
                        }
                        width={150}
                        height={6}
                    />
                ),
            },
        ],
        []
    );

    return (
        <Block gap={24} tablePadding noBorder resetMargin>
            <FlexDiv flexGrow={1} justifyEnd my={10}>
                <SearchInput
                    label=""
                    placeholder="Search"
                    searchValue={filter}
                    onChange={(e) => setFilter(e.target.value || '')}
                    onClear={() => setFilter('')}
                />
            </FlexDiv>
            <TableClient
                data={filtered}
                columns={columns}
                hidePagination={filtered.length <= 10}
            />
        </Block>
    );
}

export default observer(ScormScenarios);
